/** Studio Admin, where a handbook link to an admin page (the Integration Builder, Templates…) goes. */
export const ADMIN_URL: string = import.meta.env.VITE_ADMIN_URL ?? '/';

/** The Handbook site, for Studio Admin's links into it. */
export const HANDBOOK_URL: string = import.meta.env.VITE_HANDBOOK_URL ?? '/';

/** A Handbook page on the Handbook site, from the `/handbook/<group>/<slug>` form the content and Studio Admin use. */
export function handbookUrl(path = '/handbook'): string {
  const rest = path.replace(/^\/handbook/, '').replace(/^\//, '');
  return `${HANDBOOK_URL.replace(/\/$/, '')}/${rest}`;
}
